import type { AiCreditPackOption, UsageResourceTileConfig } from "./types";

// Prices are intentionally hardcoded for now, matching the current Stripe price list.
export const AI_CREDIT_PACK_OPTIONS: AiCreditPackOption[] = [
  {
    id: "monthly-100",
    credits: 100,
    priceUsd: 125,
    billingInterval: "monthly",
  },
  {
    id: "monthly-250",
    credits: 250,
    priceUsd: 313,
    billingInterval: "monthly",
  },
  {
    id: "monthly-500",
    credits: 500,
    priceUsd: 625,
    billingInterval: "monthly",
  },
  {
    id: "monthly-1000",
    credits: 1000,
    priceUsd: 1250,
    billingInterval: "monthly",
  },
  {
    id: "monthly-2500",
    credits: 2500,
    priceUsd: 3125,
    billingInterval: "monthly",
  },
  {
    id: "annual-100",
    credits: 100,
    priceUsd: 1200,
    billingInterval: "annual",
  },
  {
    id: "annual-250",
    credits: 250,
    priceUsd: 3000,
    billingInterval: "annual",
  },
  {
    id: "annual-500",
    credits: 500,
    priceUsd: 6000,
    billingInterval: "annual",
  },
  {
    id: "annual-1000",
    credits: 1000,
    priceUsd: 12000,
    billingInterval: "annual",
  },
  {
    id: "annual-2500",
    credits: 2500,
    priceUsd: 30000,
    billingInterval: "annual",
  },
];

export const USAGE_RESOURCE_TILES: UsageResourceTileConfig[] = [
  {
    key: "ai_builders",
    title: "Assigned AI Builders",
    subtitle: "Builder licenses assigned",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
  {
    key: "deployed_apps",
    title: "Deployed Apps",
    subtitle: "Apps currently deployed",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
  {
    key: "shared_ai_credits",
    title: "Shared AI Credits",
    subtitle: "Credits used from shared pool",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
    mocked: true,
  },
  {
    key: "integrations",
    title: "Integrations",
    subtitle: "Total configured integrations",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
];
